import FuzzySearch from "fuzzy-search";
import Contents from "Contents";
import useSearchQuery from "Hooks/useSearchQuery";
import { useMemo } from "react";
import Content from "Types/Content";

const useContentsSugestions = (): Content[] => {
  const query = useSearchQuery();
  const search = useMemo(() => query.get("query"), [query]);
  const fuzzySearcher = useMemo(
    () =>
      new FuzzySearch(Contents, ["title", "route", "tags"], {
        caseSensitive: false,
        sort: true
      }),
    []
  );

  return useMemo(
    () => (search ? fuzzySearcher.search(search) : []),
    [search, fuzzySearcher]
  );
};

export default useContentsSugestions;
